module.exports = __webpack_public_path__ + "img/bptlbarmarkeryellow.09b78e27.svg";